import React from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import {ReactComponent as BackIcon} from '../../assets/icons/arrow-left.svg';

const BackButton = (props) => {
    return (
        <Tooltip 
            arrow
            title="Back to login">
                <div>
                    <IconButton
                        aria-label="back" 
                        style={{marginTop: -7}}
                        onClick={props.onClick}
                    >
                        <BackIcon />
                    </IconButton>
                </div>
        </Tooltip>
    );
}
export default BackButton;